export function TypingDots() {
  return (
    <div className="typing" aria-label="生成中">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
